module.exports = __webpack_public_path__ + "static/media/arrow-derecha-planes.432aba95.svg";